import React from "react";
import { connect } from 'react-redux';
import User from "../assets/images/user.png";
class ProfileHeaderCard extends React.Component {
  render() {
      const {userInfo,eventsCountsData} = this.props;
    return (
      <div className="body">
        <div className="text-center">
          <img src={userInfo ? (userInfo.profile_photo_url) : User} className="rounded-circle m-b-15" alt="" />
          <div>
            <h4 className="m-b-0">
              <strong></strong> {userInfo && (userInfo.name+' '+userInfo.surname)}
            </h4>
            <span>{userInfo && (userInfo.service.name)}</span>
          </div>
          <div className="progress progress-xs m-b-25 m-t-25">
            <div
              className="progress-bar"
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: "100%" }}
            >
            </div>
          </div>

          <div className="row">
            <div className="col-4">
              <h6>{eventsCountsData && (eventsCountsData.ongoingEventsCount)}</h6>
              <span>Devam Eden</span>
            </div>
            <div className="col-4">
              <h6>{eventsCountsData && (eventsCountsData.completedEventsCount)}</h6>
              <span>Tamamlanmış</span>
            </div>
            <div className="col-4">
              <h6>{eventsCountsData && (eventsCountsData.eventsCounts)}</h6>
              <span>Tümü</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
    userInfo: state.navigationReducer.userInfo,
    eventsCountsData: state.mailInboxReducer.eventsCountsData,
});

export default connect(mapStateToProps)(ProfileHeaderCard)
